import { CloseIcon } from '@/components/base/Icons/RocheIconPack';
import IconButton from '@/storybook/components/IconButton/IconButton';
import Text from '@/storybook/components/Text/Text';
import cx from 'classnames';
import { FC, HTMLAttributes, MouseEventHandler, ReactNode } from 'react';
import ScrollArea from '../ScrollArea/ScrollArea';
import styles from './Popover.module.css';

interface PopoverPanelSectionProps {
  title?: string;
  noticeTitleProps?: HTMLAttributes<HTMLHeadingElement>;
  withCloseButton: boolean;
  useBareContent?: boolean;
  headerClassName?: string;
  titleTestId: string;
  closeButtonTestId: string;
  contentTestId: string;
  noticeContent: ReactNode;
  onClose: VoidFunction;
  onContentClick: MouseEventHandler<HTMLDivElement>;
}

const PopoverPanelSection: FC<PopoverPanelSectionProps> = ({
  title,
  noticeTitleProps,
  withCloseButton,
  useBareContent = false,
  headerClassName,
  titleTestId,
  closeButtonTestId,
  contentTestId,
  noticeContent,
  onClose,
  onContentClick,
}) => {
  const hasHeader = Boolean(title || withCloseButton);
  const isRawWithCloseOnly = useBareContent && withCloseButton && !title;
  const contentClassName = isRawWithCloseOnly
    ? styles.panelContentBareNoOverride
    : useBareContent || !hasHeader
      ? styles.panelContentBare
      : styles.panelContent;

  return (
    <div className={styles.panelSection}>
      {hasHeader && !isRawWithCloseOnly && (
        <header className={cx(styles.panelHeader, headerClassName)}>
          {title && (
            <Text as="p" className={styles.panelTitle} data-testid={titleTestId} {...noticeTitleProps}>
              {title}
            </Text>
          )}
          {withCloseButton && (
            <IconButton
              appearance="text"
              icon={<CloseIcon />}
              className={styles.panelCloseButton}
              data-testid={closeButtonTestId}
              onClick={onClose}
            />
          )}
        </header>
      )}
      {isRawWithCloseOnly && (
        <IconButton
          appearance="text"
          icon={<CloseIcon />}
          className={cx(styles.panelCloseButton, styles.panelCloseButtonAbsolute)}
          data-testid={closeButtonTestId}
          onClick={onClose}
        />
      )}
      <ScrollArea scrollbars="y" className={contentClassName}>
        <div onClick={onContentClick} data-testid={contentTestId}>
          {noticeContent}
        </div>
      </ScrollArea>
    </div>
  );
};

export default PopoverPanelSection;
